import { render } from "./FairCases.vue?vue&type=template&id=674c2272&scoped=true"
import script from "./FairCases.vue?vue&type=script&lang=js"
export * from "./FairCases.vue?vue&type=script&lang=js"

import "./FairCases.vue?vue&type=style&index=0&id=674c2272&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674c2272"]])

export default __exports__